export const buildNumber = '20240717.6';
export const version = '3.4.4';
export const latestCommit = '175510126676552ae6196b59da0e73f4623f7682';
